<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :title="'Tambah Supplier'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'vendors'"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue";
import Form from '@/component/masters/vendors/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {

  data() {
    return {
      form: {
        name: "",
        address: "",
        phone: "",
        mobile_phone: "",
        type: null,
        notes: "",
      },
    };
  },

  components: {
    Card,
    Form
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Supplier", route: "" },
      { title: "Daftar Supplier", route: "/medicine/vendors/list" },
      { title: "Tambah" },
    ])
  },

}

</script>